import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, lazy, Suspense } from 'react';
import ProtectedRoute from './components/ProtectedRoute';
import ErrorBoundary from './components/ErrorBoundary';
import AppFooter from './components/AppFooter';
import ModuleLauncher from './pages/ModuleLauncher';
import Changelog from './pages/Changelog';
import Scan from './pages/Scan';
// Mapové stránky lazy – Leaflet se načte až při otevření mapy.
const EventMapList = lazy(() => import('./pages/EventMapList'));
const EventMapPage = lazy(() => import('./pages/EventMapPage'));
import Login from './pages/Login';
import Register from './pages/Register';
import Settings from './pages/Settings';
import CheckinPage from './pages/CheckinPage';
import RemoteCheckin from './pages/RemoteCheckin';
import ChapterInventory from './pages/chapter/ChapterInventory';
import CatalogManager from './pages/superadmin/CatalogManager';
import ChaptersAdmin from './pages/superadmin/ChaptersAdmin';
import MembersAdmin from './pages/superadmin/MembersAdmin';
import AuditLog from './pages/superadmin/AuditLog';
import MuList from './pages/ops/MuList';
import MuDetail from './pages/ops/MuDetail';
import Vehicles from './pages/chapter/Vehicles';
import Containers from './pages/chapter/Containers';
import TripList from './pages/ops/TripList';
import TripDetail from './pages/ops/TripDetail';
import TripSettle from './pages/ops/TripSettle';
import Writeoffs from './pages/chapter/Writeoffs';
import FeedbackInbox from './pages/superadmin/FeedbackInbox';
import MyTrips from './pages/MyTrips';
import HandoverScan from './pages/HandoverScan';

const OPS = ['superadmin', 'ops'];
const LOGISTICS = ['superadmin', 'ops', 'chapter_rep'];
const SUPER = ['superadmin'];

export default function App() {
  useEffect(() => {
    // Aplikuj uložené preference vzhledu a přístupnosti při startu.
    const theme = localStorage.getItem('theme');
    if (theme) document.documentElement.dataset.theme = theme;
    const textSize = localStorage.getItem('textSize');
    if (textSize) document.documentElement.dataset.textSize = textSize;
  }, []);

  return (
    <BrowserRouter>
      <ErrorBoundary>
      <Routes>
        {/* Veřejné */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Rozcestník */}
        <Route path="/" element={<ProtectedRoute><ModuleLauncher /></ProtectedRoute>} />
        <Route path="/nastaveni" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        <Route path="/changelog" element={<ProtectedRoute><Changelog /></ProtectedRoute>} />
        <Route path="/sken" element={<ProtectedRoute><Scan /></ProtectedRoute>} />
        <Route path="/mu-mapa" element={<ProtectedRoute><Suspense fallback={<div className="spinner" />}><EventMapList /></Suspense></ProtectedRoute>} />
        <Route path="/mu/:id/mapa" element={<ProtectedRoute><Suspense fallback={<div className="spinner" />}><EventMapPage /></Suspense></ProtectedRoute>} />

        {/* Check-in (jakýkoli přihlášený člen) */}
        <Route path="/checkin" element={<ProtectedRoute><CheckinPage /></ProtectedRoute>} />
        <Route path="/checkin/remote" element={<ProtectedRoute><RemoteCheckin /></ProtectedRoute>} />

        {/* Sklad spolku */}
        <Route path="/sklad" element={<ProtectedRoute><ChapterInventory /></ProtectedRoute>} />

        {/* Mimořádné události (OpS) */}
        <Route path="/mu" element={<ProtectedRoute roles={OPS}><MuList /></ProtectedRoute>} />
        <Route path="/mu/:id" element={<ProtectedRoute roles={OPS}><MuDetail /></ProtectedRoute>} />

        {/* Doprava a logistika cest */}
        <Route path="/vozidla" element={<ProtectedRoute roles={LOGISTICS}><Vehicles /></ProtectedRoute>} />
        <Route path="/euroboxy" element={<ProtectedRoute roles={LOGISTICS}><Containers /></ProtectedRoute>} />
        <Route path="/cesty" element={<ProtectedRoute roles={LOGISTICS}><TripList /></ProtectedRoute>} />
        <Route path="/cesty/:id" element={<ProtectedRoute><TripDetail /></ProtectedRoute>} />
        <Route path="/cesty/:id/vyuctovani" element={<ProtectedRoute roles={['superadmin', 'chapter_rep']}><TripSettle /></ProtectedRoute>} />
        <Route path="/odpisy" element={<ProtectedRoute roles={LOGISTICS}><Writeoffs /></ProtectedRoute>} />
        <Route path="/moje-cesty" element={<ProtectedRoute><MyTrips /></ProtectedRoute>} />

        {/* Předávací QR checkpointy (přihlášený člen) */}
        <Route path="/q/h/:slug" element={<ProtectedRoute><HandoverScan /></ProtectedRoute>} />

        {/* Správa (superadmin) */}
        <Route path="/katalog" element={<ProtectedRoute roles={SUPER}><CatalogManager /></ProtectedRoute>} />
        <Route path="/spolky" element={<ProtectedRoute roles={SUPER}><ChaptersAdmin /></ProtectedRoute>} />
        <Route path="/clenove" element={<ProtectedRoute roles={LOGISTICS}><MembersAdmin /></ProtectedRoute>} />
        <Route path="/audit" element={<ProtectedRoute roles={SUPER}><AuditLog /></ProtectedRoute>} />
        <Route path="/zpetna-vazba" element={<ProtectedRoute roles={SUPER}><FeedbackInbox /></ProtectedRoute>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </ErrorBoundary>
      <AppFooter />
    </BrowserRouter>
  );
}
